import { AmaxPayOpenBankingBankAccount } from 'shared/data/webApp/v1';

export const mapMaxPayOpenBankingBankAccount = ({
    consent,
    identification,
    ...item
}: AmaxPayOpenBankingBankAccount) => {
    return {
        ...item,
        ...identification,
        consentId: consent.id,
        status: consent.status,
    };
};
